import styled, { keyframes } from "styled-components";

export const FadeAnimation = keyframes`
 from { opacity: 0; }
 to { opacity:1;}
 `;

export const AnimationDuration = "1.5s";
